// src/api/health.js

export async function getProviderHealth(forceRefresh = false) {
  const url = forceRefresh ? "/providers/health?force_refresh=true" : "/providers/health";
  const response = await fetch(url);
  if (!response.ok) throw new Error("Failed to fetch provider health");
  return await response.json();
}

export async function getProviderHealthHistory(limit = 10) {
  const response = await fetch(`/providers/health/history?limit=${encodeURIComponent(limit)}`);
  if (!response.ok) throw new Error("Failed to fetch provider health history");
  const payload = await response.json();
  return Array.isArray(payload?.history) ? payload.history : [];
}
